import { useIsMobile } from '@/hooks/use-mobile';
import logoFull from '@/assets/logo-full.png';
import logoRect from '@/assets/logo-rect.png';
import logoSquare from '@/assets/logo-square.png';

type Variant = 'full' | 'rect' | 'square' | 'app-auto';

interface LogoProps {
  variant?: Variant;
  className?: string;
  alt?: string;
}

/**
 * Centralized logo system.
 * - full: marketing/landing/login (wide, with tagline)
 * - rect: inner app desktop header (no tagline)
 * - square: mobile / collapsed sidebar
 * - app-auto: rect on desktop, square on mobile
 */
export function Logo({ variant = 'app-auto', className, alt = 'PullOver.App' }: LogoProps) {
  const isMobile = useIsMobile();
  const resolved = variant === 'app-auto' ? (isMobile ? 'square' : 'rect') : variant;

  const src =
    resolved === 'full' ? logoFull : resolved === 'square' ? logoSquare : logoRect;

  return <img src={src} alt={alt} className={className} draggable={false} />;
}
